<div class="view-toggle">
  <ng-container *ngFor="let view of views">
    <!-- Route mode -->
    <a *ngIf="view.routerLink != null"
       class="view-toggle-btn"
       [class.view-toggle-btn--active]="isActive(view)"
       [routerLink]="view.routerLink"
       [title]="view.tooltip || ''">
      <app-svg-icon [icon]="$any(view.icon)" [size]="20" [strokeWidth]="1.5"></app-svg-icon>
    </a>
    <!-- Event mode -->
    <button *ngIf="view.routerLink == null"
       class="view-toggle-btn"
       [class.view-toggle-btn--active]="isActive(view)"
       [title]="view.tooltip || ''"
       (click)="onSelect(view)">
      <app-svg-icon [icon]="$any(view.icon)" [size]="20" [strokeWidth]="1.5"></app-svg-icon>
    </button>
  </ng-container>
</div>
